
const VerticalLayout = () => import('@/layouts/VerticalLayout')

const settingsList = () => import('./views/list')
const profileSetting = () => import('./views/profile')
const activityLines = () => import('./views/activityLines')
const activityTypes = () => import('./views/activityTypes')
const durationList = () => import('./views/durationLists')
const amenitiesList = () => import('./views/amenities')
const nationalities = () => import('./views/nationalities')
const accommodationTypes = () => import('./views/accommodationTypes')
const links = () => import('./views/links')
const languages = () => import('./views/languages')
const countries = () => import('./views/countries')
const cities = () => import('./views/cities')
const areas = () => import('./views/areas')
const paymentMethods = () => import('./views/paymentMethods')
const level = () => import('./views/level')
const tags = () => import('./views/tag')
const packages = () => import('./views/packages')
const premium = () => import('./views/premium')
// Tabs with no permission of their own open for anyone who can open any settings tab.
const anySetting = ['setting_list', 'activity_line_list', 'duration_list_list', 'amenity_list', 'nationality_list', 'link_list', 'language_list', 'country_list', 'city_list', 'area_list', 'level_list', 'tag_list', 'package_list']

// Settings tabs, in nav order (tabs missing from the nav last); a tab the admin can't open falls back to the next allowed one.
const fallbackRoutes = ['settings', 'premium', 'paymentMethods', 'packages', 'durationLists', 'levels', 'tags', 'amenities', 'links', 'languages', 'countries', 'cities', 'areas', 'activityLines', 'activityTypes', 'nationalities', 'accommodationTypes']

export default [
  {
    path: '/settings',
    name: 'settings',
    component: VerticalLayout,
    meta: { auth: true },
    children: [{
      path: '',
      name: 'settings',
      meta: { auth: true, name: 'settings' },
      component: settingsList,
      children: [
        {
          path: '',
          name: 'settings',
          meta: { name: 'settings', userType: 'admin', permission: 'setting_list', fallbackRoutes },
          component: profileSetting
        },
        {
          path: 'activity-lines',
          name: 'activityLines',
          meta: { name: 'activityLines', userType: 'admin', permission: 'activity_line_list', fallbackRoutes },
          component: activityLines
        },
        {
          path: 'activity-types',
          name: 'activityTypes',
          meta: { name: 'activityTypes', userType: 'admin', permission: anySetting, fallbackRoutes },
          component: activityTypes
        },
        {
          path: 'duration-lists',
          name: 'durationLists',
          meta: { name: 'durationLists', userType: 'admin', permission: 'duration_list_list', fallbackRoutes },
          component: durationList
        },
        {
          path: 'amenities',
          name: 'amenities',
          meta: { name: 'amenities', userType: 'admin', permission: 'amenity_list', fallbackRoutes },
          component: amenitiesList
        },
        {
          path: 'nationalities',
          name: 'nationalities',
          meta: { name: 'nationalities', userType: 'admin', permission: 'nationality_list', fallbackRoutes },
          component: nationalities
        },
        {
          path: 'accommodation-types',
          name: 'accommodationTypes',
          meta: { name: 'accommodationTypes', userType: 'admin', permission: anySetting, fallbackRoutes },
          component: accommodationTypes
        },
        {
          path: 'links',
          name: 'links',
          meta: { name: 'links', userType: 'admin', permission: 'link_list', fallbackRoutes },
          component: links
        },
        {
          path: 'languages',
          name: 'languages',
          meta: { name: 'languages', userType: 'admin', permission: 'language_list', fallbackRoutes },
          component: languages
        },
        {
          path: 'countries',
          name: 'countries',
          meta: { name: 'countries', userType: 'admin', permission: 'country_list', fallbackRoutes },
          component: countries
        },
        {
          path: 'cities',
          name: 'cities',
          meta: { name: 'cities', userType: 'admin', permission: 'city_list', fallbackRoutes },
          component: cities
        },
        {
          path: 'areas',
          name: 'areas',
          meta: { name: 'areas', userType: 'admin', permission: 'area_list', fallbackRoutes },
          component: areas
        },
        {
          path: 'payment-methods',
          name: 'paymentMethods',
          meta: { name: 'paymentMethods', userType: 'admin', permission: anySetting, fallbackRoutes },
          component: paymentMethods
        },
        {
          path: 'levels',
          name: 'levels',
          meta: { name: 'levels', userType: 'admin', permission: 'level_list', fallbackRoutes },
          component: level
        },
        {
          path: 'tags',
          name: 'tags',
          meta: { name: 'tags', userType: 'admin', permission: 'tag_list', fallbackRoutes },
          component: tags
        },
        {
          path: 'packages',
          name: 'packages',
          meta: { name: 'packages', userType: 'admin', permission: 'package_list', fallbackRoutes },
          component: packages
        },
        {
          path: 'premium',
          name: 'premium',
          meta: { name: 'premium', userType: 'admin', permission: 'setting_list', fallbackRoutes },
          component: premium
        }
      ]
    }
    ]
  }
]
